<style scoped="scoped" lang="scss">
/* .baoyangxianginput {
  width: 30px;
} */
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 120px;
}
</style>
<template>
  <div style="display: inline;">

    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/page" getKey="rows"
        :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :selectTitle="'name'" :component="'web_base_matter_list'"
                :ids.sync="yt.conditions.materialIdList">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId">
            </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('daipaichan')" :value="1"></el-option>
              <el-option :label="$t('yipaichan')" :value="2"></el-option>
              <el-option :label="$t('guanbi')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planStartTimeStart"
                           :end.sync="yt.conditions.planStartTimeEnd">
            </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planEndTimeStart"
                           :end.sync="yt.conditions.planEndTimeEnd">
            </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w2',beforeShowEditDialog);setDefaultValue1()"
          type="primary" v-if="utils.checkPower('web_order_management_production_plan_customized_create')">
          {{$t('xinzeng')}}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('hedan',null,'80%');" type="primary" plain v-if="utils.checkPower('web_order_management_production_plan_customized_mergeList')">
          {{$t('hedan')}}
        </el-button>
        <el-button style="margin-left: 10px;" size="mini" @click="show = !show" plain v-if="utils.checkPower('web_order_management_production_plan_customized_importExcel')">
          {{$t('daoru')}}
        </el-button>
        <el-button style="margin-left: 10px;" size="mini" @click="schedulingShow = !schedulingShow" plain v-if="utils.checkPower('web_order_management_production_plan_customized_schedulingImportExcel')">
          {{$t('daorupaichanfafang')}}
        </el-button>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button :loading="plan_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()" v-if="utils.checkPower('web_order_management_production_plan_customized_export')">
        </el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #shifoujiafen="scope">
       <span>{{scope.row.addPowder==null?'':scope.row.addPowder==true?$t('shi'):$t('fou')}}</span>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col v-if="scope.row.children || (scope.row.parentId == null)" :span="0.1">
            <el-button v-if="scope.row.status==1 && utils.checkPower('web_order_management_production_plan_customized_scheduling')" type="text"
              @click="yt.showEditDialog('paichan', scope.row,'w1');setDefaultValue();">
              {{$t('paichan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.schedulingQuantity>0 && utils.checkPower('web_order_management_production_plan_customized_woForPlan')" type="text"
              @click="yt.showEditDialog('shengchangongdan', scope.row,'900px')">
              {{$t('shengchangongdan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="(scope.row.children || (scope.row.parentId == null)) && utils.checkPower('web_order_management_production_plan_customized_update')">
            <el-button v-if="scope.row.status==1" type="text"
                @click="yt.showEditDialog('bianji', scope.row,'w2', beforeEdit)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="scope.row.type==1 && utils.checkPower('web_order_management_production_plan_customized_merge_list')"
                @click="yt.showEditDialog('hedanjilu', scope.row,'900px')">
              {{$t('hedanjilu')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.schedulingQuantity==0 && utils.checkPower('web_order_management_production_plan_customized_delete')" type="text" class="font-color-danger"
              @click="yt.remove(scope.row,'/web/production/plan/delete')">
              {{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{$t('zhuchanpin')}}</p>
            <el-form-item :label="$t('jihuadanhao')" required>
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId">
              </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
              <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'"
                  :ids.sync="yt.editObj.materialId">
              </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime"
                  :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')">
              </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
                  v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">{{$t('yimuduopin')}}</p>
            <div v-if="yt.editObj.children.length >0">
              <el-form-item style="margin-left: 5px;" :label="$t('jihuadanhao')" label-width="130px" required>
              </el-form-item>
              <el-form-item style="margin-left: 20px;" :label="$t('chanpinbianma/mingcheng')"
                  label-width="130px" required>
              </el-form-item>
              <el-form-item style="margin-left: -20px;" :label="$t('jihuashuliang')" label-width="105px"
                  required>
              </el-form-item>
              <el-form-item style="margin-left: 15px;" :label="$t('ERPgongdanhao')" label-width="105px">
              </el-form-item>
              <el-form-item style="margin-left: -25px;" :label="$t('beizhu')" label-width="105px">
              </el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">

                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)">
                  </el-button>
                </el-col>
                <template>
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input v-model="item.no" type="text" size="mini">
                    </el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'"
                        :ids.sync="item.materialId">
                    </yi_cross_select>
                    <!-- <el-input v-model="item.materialId" type="text" size="mini">
                    </el-input> -->
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
                        v-model="item.quantity" size="mini">
                    </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini">
                    </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini">
                    </el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br/>
            <el-form-item size="mini" style="margin-top: -20px;">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{$t('zengjiayitiaofuchanpin')}}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
              @click="yt.req('POST','/web/production/plan/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{$t('zhuchanpin')}}</p>
            <el-form-item class="noborder" :label="$t('jihuadanhao')" required>
              <el-input disabled v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId">
              </yi_data_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
              <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'"
                  :ids.sync="yt.editObj.materialId">
              </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime"
                  :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')">
              </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
                  v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">{{$t('yimuduopin')}}</p>
            <!--            scope.row.children || (scope.row.parentId == null)-->

            <div v-if="yt.editObj.children.length >0">
              <el-form-item style="margin-left: 5px;" :label="$t('jihuadanhao')" label-width="130px" required>
              </el-form-item>
              <el-form-item style="margin-left: 20px;" :label="$t('chanpinbianma/mingcheng')"
                  label-width="130px" required>
              </el-form-item>
              <el-form-item style="margin-left: -20px;" :label="$t('jihuashuliang')" label-width="105px"
                  required>
              </el-form-item>
              <el-form-item style="margin-left: 15px;" :label="$t('ERPgongdanhao')" label-width="105px">
              </el-form-item>
              <el-form-item style="margin-left: -25px;" :label="$t('beizhu')" label-width="105px">
              </el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)">
                  </el-button>
                </el-col>

                <template v-if="yt.editObj.children.length > 0 ||parentIds">
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input disabled v-model="item.no" type="text" size="mini">
                    </el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'"
                        :ids.sync="item.materialId">
                    </yi_cross_select>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
                        v-model="item.quantity" size="mini">
                    </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini">
                    </el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini">
                    </el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br/>
            <el-form-item size="mini" style="margin-top: -20px;"
                v-if="yt.editObj.children ==null && (yt.editObj.parentId == null)">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{$t('zengjiayitiaofuchanpin')}}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
              @click="yt.req('POST','/web/production/plan/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!-- 排产 -->
      <template v-if="yt.editObj.action == 'paichan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <div style="display: flex;flex-wrap: nowrap;align-items: center;font-family:Microsoft YaHei UI;margin-bottom: 16px;font-size: 16px;">
              <span>{{$t('zhuchanpin')}}:</span>
              <span style="margin-left: 10px;">{{yt.editObj.material.name}}</span>
            </div>
            <el-form-item :label="$t('mujubianhao/mingcheng')" required>
              <yi_cross_select :max="1" :selectTitle="'no,name'" @getItems="getItems"
                  :component="'web_order_management_production_plan_mold_list'"
                  :ids.sync="yt.editObj.mouldId" :materialId="yt.editObj.materialId">
              </yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_cross_select :disabled="disabled1" :max="1"
                  :component="'web_order_management_production_plan_equipment_list'"
                  :ids.sync="yt.editObj.equipmentId" :mouldId="yt.editObj.mouldId" :materialId="yt.editObj.materialId">
              </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('kepaichanshuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
                  v-model="scheduling">
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('bencijihuashuliang')" required>
              <el-input-number v-model="yt.editObj.curQuantity" :precision="0"
                  :disabled="yt.editObj.mouldId === undefined || yt.editObj.mouldId === ''" :max="maxValue"
                  @input="changePlanNumber"/>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishishijian')" required>
              <!--              :minTime="3600*1*24*1000" :maxTime="3600*365*24*1000"-->
              <yi_time_input :disabled="yt.editObj.mouldId === undefined || yt.editObj.mouldId === ''"
                  :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.startTime"
                  @update:time="changeStartTime">
              </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuawanchengshijian')" required>
              <yi_time_input :disabled="yt.editObj.mouldId === undefined || yt.editObj.mouldId === ''" type="datetime"
                  :time.sync="yt.editObj.endTime" @update:time="changeEndTime">
              </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('gongdanshunxu')" required>
              <el-input type="number" @input="onInput()" oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')"
                  v-model="yt.editObj.priority"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shijimoqiangshu')"
                          required="required"
                          label-width="145px">
              <el-input-number v-model="yt.editObj.actualCavity" controls-position="right"  :min="1" ></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <!-- 子计划单 -->
            <div v-for="(item, index) in yt.editObj.children" :key="index">
              <div
                  style="display: flex;flex-wrap: nowrap;align-items: center;font-family:Microsoft YaHei UI;margin-bottom: 16px;font-size: 16px;">
                <span>{{$t('yimuduopin')}}:</span>
                <span v-if="item.material" style="margin-left: 10px;">{{item.material.name}}</span>
              </div>
              <el-form-item class="noborder" :label="$t('kepaichanshuliang')">
                <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')"
                    v-model="item.quantity-item.schedulingQuantity"></el-input>
              </el-form-item>
              <el-form-item :label="$t('bencijihuashuliang')" required>
                <el-input-number v-model="item.curQuantity" :precision="0" :max="maxValue2"/>
              </el-form-item>
              <el-form-item :label="$t('shijimoqiangshu')"
                            required="required"
                            label-width="145px">
                <el-input-number v-model="item.actualCavity" controls-position="right" :min="1" ></el-input-number>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
              @click="yt.req('POST','/web/production/plan/scheduling')" type="primary">
						{{$t('baocun')}}
					</el-button>
					<el-button size="mini" :loading="yt.editObj.loading"
              @click="yt.req('POST','/web/production/plan/schedulingAndGiveOut')" type="primary">
						{{$t('baocunbingpaichanfafang')}}
					</el-button>
				</span>
      </template>
      <!-- 合单记录 -->
      <template v-if="yt.editObj.action == 'hedanjilu'">
        <div class="dialog-scroller">
          <combination_record :record="yt.editObj" ></combination_record>
        </div>
      </template>
      <!-- 合单 -->
      <template v-if="yt.editObj.action == 'hedan'">
        <div class="dialog-scroller">
          <combine ref="combineOrders"></combine>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="submitCombine" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <template v-if="yt.editObj.action == 'shengchangongdan'">
        <div class="dialog-scroller">
          <work_order :work="yt.editObj"></work_order>
        </div>

      </template>
    </el-dialog>
    <!-- 导入excel -->
    <importExcel :show.sync="show"/>
    <schedulingImportExcel :schedulingShow.sync="schedulingShow"/>
  </div>
</template>
<script type="text/javascript">

import combine from '@@/pages/web/order_management/production_plan_customized/combine'
import importExcel from '@@/pages/web/order_management/production_plan_customized/import_excel'
import schedulingImportExcel from '@@/pages/web/order_management/production_plan_customized/scheduling_import_excel'
import work_order from '@@/pages/web/order_management/production_plan_customized/work_order/list'
import combination_record from '@@/pages/web/order_management/production_plan_customized/combination_record'

export default {
  name: 'web_order_management_production_plan_customized_list',
  components: {
    importExcel,
    schedulingImportExcel,
    combine,
    work_order,
    combination_record
  },
  data() {
    return {
      plan_export_loading: false,
      actualCavity:'',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      parentIds: '',
      scheduling: '',
      cavity: '',
      cycle: '',
      showTitle: false,
      showTitle1: false,
      disabled1: true,
      show: false,
      schedulingShow: false,
      leaveFactoryDate: (new Date()).getFullYear() + '-' + ((new Date()).getMonth() + 1) + '-' + (new Date())
          .getDate(),
      list: [],
      orderBy: {
        orderBy: "createTime desc"
      },
      columns: [{
        label: 'jihuadanhao',
        prop: 'no',
        sort: 'string',
        width: 130,
      }, {
        label: 'ERPgongdanhao',
        prop: 'erpNo',
        sort: 'string',
        width: 130,
      }, {
        label: 'chanpinbianma',
        prop: 'material.code',
        sort: 'string',
        width: 130,
      }, {
        label: 'chanpinmingcheng',
        prop: 'material.name',
        sort: 'string',
        width: 130,
      }, {
        label: 'jihuashuliang',
        prop: 'quantity',
        sort: 'number',
        width: 130,
      }, {
        label: 'yipaichanshuliang',
        prop: 'schedulingQuantity',
        width: 130,
      }, {
        label: 'guishuchejian',
        prop: 'org.name',
      }, {
        label: 'zhuangtai',
        type: 'tag',
        prop: 'status',
        tags: {
          1: {
            color: '#E6A23C',
            text: this.$t('daipaichan')
          },
          2: {
            color: '#67C23A',
            text: this.$t('yipaichan')
          },
          3: {
            color: '#f56c6c',
            text: this.$t('guanbi')
          }
        },
      }, {
        label: 'jihuakaishishijian',
        prop: 'startTime',
        type: 'time',
        width: 150,
      }, {
        label: 'jihuawanchengshijian',
        prop: 'endTime',
        type: 'time',
        width: 150,
      },
        {
          label: 'shifoujiafen',
          prop: 'addPowder',
          type: 'slot',
          width: 130,
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130,
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ],

      ids: ''
    };
  },
  computed: {
    maxValue() {
      return this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity
    },
    maxValue2() {
      const quantity = this.yt.editObj.children.map(qt => {
        return qt.quantity
      })
      const schedulingQuantity = this.yt.editObj.children.map(items => {
        return items.schedulingQuantity
      })
      return (quantity + '') - (schedulingQuantity + '')
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
      }
      this.yt.get(1);
      this.yt.isShowPagination = true;
      this.utils.event_hub.$on('ORDER_MANAGEMENT_CUSTOMIZED_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },
  watch: {
    'yt.editObj.mouldId': {
      handler(n) {
        if (n) {
          this.disabled1 = false
        }
      },
      immediate: false,
      deep: true
    },
    "yt.editObj.action": {
      handler(n) {
        if (n === 'xinzeng') {
          this.yt.editObj.children = []
        }
        if (n === 'paichan') {
          if (this.yt.editObj) {
            this.scheduling = this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity
          }
        }
      },
      immediate: false,
      deep: true
    },
    "yt.editObj.curQuantity": {
      handler(n) {
        if (n > this.scheduling) {
          n = this.scheduling
          this.$set(this.yt.editObj, 'curQuantity', n.toFixed(0))
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    //导出
    exportExcel() {
      let params = this.yt.conditions
      params.materialId = this.yt.conditions.materialIdList
      params.startTimeStart = this.yt.conditions.startTime
      params.startTimeEnd = this.yt.conditions.endTime
      delete params.startTime
      delete params.endTime
      delete params.materialIdList
      delete params.orderBy
      this.plan_export_loading = true;
      return this.http.get('/web/report/export/production_plan_export', {
        params
      }).then(res => {
        this.$message.success(this.$t(res.msg))
        this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
      }).catch(error => {
        this.$message.error(this.$t(error))
      }).finally(() => {
          this.plan_export_loading = false;
      })
    },
    /**
     * 计划数量
     * @param value
     */
    changePlanNumber(value) {
      // 计划完成时间=计划开始时间(时间戳)+本次计划数量*标准周期*1000/模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        const endTime = this.yt.editObj.startTime + this.yt.editObj.curQuantity * this.cycle * 1000 / this.cavity
        this.$set(this.yt.editObj, 'endTime', endTime)
      }
    },
    /**
     * 计划开始时间
     * @param value
     */
    changeStartTime(value) {
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuakaishishijianbunengdayujiahuawanchengshijian'))
        this.yt.editObj.startTime = ''
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        const endTime = this.yt.editObj.startTime + this.yt.editObj.curQuantity * this.cycle * 1000 / this.cavity
        this.$set(this.yt.editObj, 'endTime', endTime)
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        const curQuantity = (this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle * this.cavity
        this.$set(this.yt.editObj, 'curQuantity', curQuantity)
      }
    },
    /**
     * 计划结束时间
     * @param value
     */
    changeEndTime(value) {
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuawanchengshijianbunengxiaoyujihuakaishishijian'))
        this.yt.editObj.endTime = ''
      }
      // 本次计划数量=(计划完成时间(时间戳)-计划开始时间(时间戳))/1000/标准周期*模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        const curQuantity = (this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle * this.cavity
        this.$set(this.yt.editObj, 'curQuantity', curQuantity)
      }
    },
    /**
     * 选中模糊
     * @param items
     */
    getItems(items) {
      this.cavity = items.cavity
      this.cycle = items.cycle
      this.actualCavity = items.actualCavity
      if(this.actualCavity){
        this.$set(this.yt.editObj,'actualCavity',this.actualCavity)
        if(this.yt.editObj.children){
          for (let i = 0; i < this.yt.editObj.children.length; i++) {
            this.$set(this.yt.editObj.children[i],'actualCavity',this.actualCavity)
          }
        }
      }
    },

    setDefaultValue1() {
      if (
          this.store.state.organizations.length > 0 &&
          this.store.state.organizations[0].children.length > 0 &&
          this.store.state.organizations[0].children[0].children.length > 0
      ) {
        this.yt.editObj.orgId = this.store.state.organizations[0].children[0].children[0]['id']
      }
    },
    onInput() {
      this.$forceUpdate();
    },
    beforeEdit(editObj) {
      if (editObj.children === undefined) {
        this.$set(editObj, 'children', [])
      }
      return editObj
    },
    setDefaultValue() {
      this.yt.editObj.priority = 1;
      this.yt.editObj.startTime = []
      this.yt.editObj.endTime = []

    },
    submitCombine() {
      let planIdList = this.$refs['combineOrders'].planIdList
      if (planIdList !== null) {
        this.yt.editObj.loading = true;
        return this.http.post('/web/production/plan/merge', planIdList).then(response => {
          this.yt.get(1)
          this.yt.isShowEditDialog = false;
        }).catch(error => {
          this.$message.error(error)
        }).finally(() => {
            this.yt.editObj.loading = false;
        })
      } else {
        this.utils.errorMessage(this.$t('请选择需要的单'))
      }

    },

    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng') {
        editObj.children = [{
          no: '',
          materialId: '',
          quantity: undefined,
          erpNo: '',
          remark: ''
        }]
      }
      return editObj
    },
    addItem() {
      this.showTitle = true
      this.showTitle1 = true
      console.log('this.yt.editObj.children', this.yt.editObj.children)
      this.yt.editObj.children.push({
        no: '',
        materialId: '',
        quantity: undefined,
        erpNo: '',
        remark: ''
      })
    },
    deleteItem(key) {
      this.yt.editObj.children = this.yt.editObj.children.filter((item, index) => {
        return index !== key
      })
    }
  },
};
</script>
